// "Related User" filtresinde gösterilecek kullanıcılar (e-posta ile eşleşir).
export const RELATED_USER_EMAILS = [
  "can@newtvgeneration.com",
  "can.oguz@newtvgeneration.com",
  "melisa@newtvgeneration.com",
  "furkan@newtvgeneration.com",
  "serra.citak@newtvgeneration.com",
];

export const filterRelatedUsers = (users = []) =>
  users.filter((u) =>
    RELATED_USER_EMAILS.includes((u.email || "").trim().toLowerCase())
  );
